<template>
    <div class="title-section" :style="getStyle()" :class="background">
        <div class="title-main">
            <div class="container">
                <div class="row">
                    <div class="col-md-10">
                        <h1 class="p-white p-title relawayBold">Find the best and cheapest electricity deal in Stockholm</h1>
                        <div class="breadcrumbs">
                            <span>
                                <a href="#">
                                    Home
                                </a>
                            </span>
                            <span class="separator">
                                <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                                :style="GetSvgStyle()"
                                                stroke-width="0.2" d="M1.39614 11.1C1.52503 11.1 1.64589 11.0577 1.7429 10.9712L6.95063 6.32462C7.14979 6.14692 7.14979 5.85308 6.95063 5.67538L1.7429 1.02883C1.55038 0.857056 1.24189 0.857056 1.04937 1.02883C0.850211 1.20653 0.850211 1.50037 1.04937 1.67806L5.89327 6L1.04937 10.3219C0.850211 10.4996 0.850211 10.7935 1.04937 10.9712C1.14638 11.0577 1.26724 11.1 1.39614 11.1Z" />
                                </svg>
                            </span>

                            <span>
                                <a href="#">
                                    Home2
                                </a>
                            </span>
                            <span class="separator">
                                <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                                :style="GetSvgStyle()"
                                                stroke-width="0.2" d="M1.39614 11.1C1.52503 11.1 1.64589 11.0577 1.7429 10.9712L6.95063 6.32462C7.14979 6.14692 7.14979 5.85308 6.95063 5.67538L1.7429 1.02883C1.55038 0.857056 1.24189 0.857056 1.04937 1.02883C0.850211 1.20653 0.850211 1.50037 1.04937 1.67806L5.89327 6L1.04937 10.3219C0.850211 10.4996 0.850211 10.7935 1.04937 10.9712C1.14638 11.0577 1.26724 11.1 1.39614 11.1Z" />
                                </svg>
                            </span>
                            <span>Some page name</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "titlePart",
        props: ['background'],
        methods:{
            GetSvgStyle(){
                if(this.background === "background-grey"){
                    return {
                        'fill': '#545454',
                        'stroke': '#545454'
                    }
                } else {
                    return {
                        'fill': 'white',
                        'stroke': 'white'
                    }
                }
            },
            getStyle(){
                if(this.background === "background-grey"){
                    return {
                        'backgroundColor': '#F7F9F9'
                    }
                } else {
                    return {
                        'backgroundImage': 'url(\'../../../../img/stockholm-market.png\')'
                    }
                }
            }
        }
    }
</script>
